import dayjs, { duration } from 'dayjs';

dayjs.extend(duration);

export const isSameDate = (session) => {
  if (!session?.start_time || !session?.end_time) return false;

  return dayjs(new Date(session.start_time * 1000))?.isSame(
    new Date(session.end_time * 1000),
    'day'
  );
};

export const formatDate = (session, fullDate = false) => {
  const startDate = dayjs(new Date((session?.start_time || 0) * 1000)).format(
    fullDate ? 'DD MMMM HH:mm' : 'DD/MM HH:mm'
  );
  const isSame = isSameDate(session);
  if (isSame) {
    return (
      startDate +
      dayjs(new Date((session?.end_time || 0) * 1000)).format(' - HH:mm')
    );
  }
  return startDate;
};

export const sessionDuration = (session = {}) => {
  if (!session?.start_time || !session?.end_time) return false;

  const start = dayjs(new Date(session.start_time * 1000));
  const end = dayjs(new Date(session.end_time * 1000));
  const diff = end.diff(start);
  return dayjs.duration(diff, 'milliseconds').humanize();
};

export const humanize = (timestamp = 0) => {
  const now = dayjs();
  const diff = now.diff(dayjs(new Date(timestamp * 1000)));
  return dayjs.duration(diff, 'milliseconds').humanize();
};
